exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-list{display:inline-block;position:relative}.menu-list .menu-items{margin:0;padding:0;list-style:none;display:inline-block;outline:none}.menu-list .options-menu{position:absolute}.menu-list .options-menu .options-menu-item{border-bottom:1px solid #ddd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Common/MenuList/MenuList.vue
// module id = 171
// module chunks = 20